// MapView Selected Filter Keys
export const MapViewSelectedFilterKeys = {
  selectedSubZoneIds: "selectedSubZoneIds",
  selectedRouteTypes: "selectedRouteTypes",
  selectedMediaTypes: "selectedMediaTypes",
};
